import thisPageUnderConstruction from "@assets/img/this-page-is-under-construction_8.jpg";
export const NotFoundPage = () => (
  <img src={thisPageUnderConstruction} alt="Page Under Construction" />
);
